import React from 'react';

// A titled card section of the claim form.
const FormCard = ({ title, icon, children, headerContent }) => (
    <div className="bg-surface p-8 border border-line mb-8 rounded-none">
        <div className="flex justify-between items-center border-b border-line pb-4 mb-6">
            <div className="flex items-center">
                <span className="text-text-main mr-4 text-lg"><i className={`fas ${icon}`}></i></span>
                <h5 className="text-sm font-semibold text-text-main uppercase tracking-widest">{title}</h5>
            </div>
            {headerContent}
        </div>
        {children}
    </div>
);

export default FormCard;
